'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './code-list.routes';

export class ActivationCodeListComponent {
  constructor(Auth, ActivationCodeService, dialogs, $uibModal, $state) {
    'ngInject';

    this.ActivationCodeService = ActivationCodeService;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.loadData();
  }

  loadData() {
    this.ActivationCodeService.query((data) => {
      this.transformData(data);
    }, err => {
      console.log("Could not retrieve activation codes.")
    })
  }

  transformData(data) {
    this.data = data;
    this.permanent = data.filter(code => !code.isOneTimeCode);

    let onetime = data.filter(code => code.isOneTimeCode);

    this.onetimeSeeds = [];
    this.onetime = {};

    for (let i=0; i<onetime.length; i++) {
      if (!this.onetime[onetime[i].seedId]) {
        this.onetime[onetime[i].seedId] = [];
      }

      this.onetime[onetime[i].seedId].push(onetime[i]);
    }

    let seedIds = Object.keys(this.onetime);
    seedIds.forEach(seedId => {
      this.onetimeSeeds.push({
        id: seedId,
        group: this.onetime[seedId][0].group,
        date: this.onetime[seedId][0].seedDate,
        count: this.onetime[seedId].length
      })
    });
  }

  openCreateModal() {

    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'activationCodeCreate',
      resolve: {
        config: function () {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (type) {
        if (type == 'permanent') {
          that.$state.go("activation-code-edit");
        } else if (type  == 'onetime') {
          that.loadData();
        }
      },
      function () {
      }
    );
  }

  getCsvData(data) {
    return data.map(entry => {
      return [entry.code, entry.group, (entry.isTaken) ? "x" : "-", (entry.isTaken) ? entry.takenBy : "-", (entry.isTaken) ? entry.takenAt : "-"];
    })
  }

  deleteSeed(seed) {
    var that = this;

    var seedText = "<br/><br/>Seed from <b>" + new Date(seed.date).toLocaleString() + "</b> of group <em>"+ seed.group +"</em>";

    var dlg = this.dialogs.confirm("Delete Activation Codes?", "Do you really want to delete all " + seed.count + " one-time activation codes in this seed?" + seedText);
    dlg.result.then(() => {
      // OK delete it
      that.ActivationCodeService.deleteSeed({seedId: seed.id},
        () => {
          that.loadData();
        },
        err => {
          alert("Could not delete activation codes");
        });
    }, () => {
      // Cancel
    });

  }

  delete(code) {
    var that = this;

    var codeText = "<br/><br/><b>" + code.code + "</b> of group <em>"+ code.group +"</em><br/><p>" + code.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Activation Code?", "Do you really want to delete the activation code?" + codeText);
    dlg.result.then(() => {
      // OK delete it
      that.ActivationCodeService.delete({id: code._id},
        () => {
          that.loadData();
        },
        err => {
          alert("Could not delete activation code");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.activationCodeList', [uiRouter])
  .config(routes)
  .component('activationCodeList', {
    template: require('./code-list.html'),
    controller: ActivationCodeListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/activation-code/list/code-list.component.js